import { getDate, getDay, parseISO } from 'date-fns'

import { daysOfWeek, extractDatePart, getRideTime } from './time'
import { getRidersByRideTimeByClass } from '../pages/organizer/manage/ManageClinicNOtherOperationsTab/components/OrderOfGoTable/data/order-of-go-rider-utils'

import { FeesTypeItem } from '../models/event-fees/event-fees.interface'
import { TCustomSchedule } from '../models/event-scheduling/event-scheduling.interface'
import { IRegistrationByDayInterface } from '../models/registrations-by-day/registrationByDay.interface'
import { IBreak } from '../models/events/event.interface'

export const getGroupScheduleByDay = (schedules: (FeesTypeItem | TCustomSchedule)[]) => {
  return schedules.reduce((acc: any, currentEvent) => {
    const extractedDate = extractDatePart(currentEvent.startDate)
    const parsedDate = parseISO(extractedDate)
    const day = daysOfWeek[getDay(parsedDate)]
    const dayOfMonth = getDate(parsedDate)
    const date = `${day}_${dayOfMonth}`
    if (date) acc[date] = [...(acc[date] ?? []), currentEvent]
    return acc
  }, {})
}

export const getFeeTime = (
  registrationsByDay: (IRegistrationByDayInterface | IBreak)[],
  registrationByDay: IRegistrationByDayInterface,
  fee: FeesTypeItem | TCustomSchedule,
  scheduleBy: 'class' | 'rider'
) => {
  let displayTime
  if (scheduleBy === 'rider') {
    displayTime = registrationByDay?.orderOfGoScratched
      ? 'Dropped'
      : registrationByDay?.rideTime
        ? getRideTime(registrationByDay.rideTime)
        : 'Not Set'
  } else if (scheduleBy === 'class' && fee.increment) {
    const ridersByRideTimeByClass = getRidersByRideTimeByClass(
      registrationsByDay,
      fee as FeesTypeItem,
      fee.increment
    )
    const current = ridersByRideTimeByClass.find((item) => item.id === registrationByDay.id)
    displayTime = registrationByDay?.orderOfGoScratched
      ? 'Dropped'
      : current?.rideTimeScheduleByClass
  }

  return displayTime
}
